import { createAsyncStateHook } from './utils'
import { getTags } from 'src/services/tagServices'

export const useTags = createAsyncStateHook('tags', getTags)
